import {Component, inject, OnInit, Renderer2} from '@angular/core';
import {AuthService} from "./shared/services/auth.service";
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer, Title} from "@angular/platform-browser";
import {FirebaseService} from "./shared/services/firebase.service";
import {getBrowserLang, TranslocoModule, TranslocoService} from "@jsverse/transloco";
import {MatDialog} from "@angular/material/dialog";
import {BrandService} from "./shared/services/brand.service";
import {LogoService} from "./shared/services/logo.service";
import {CookieSettingsComponent} from "./shared/components/cookie-notice/cookie-settings/cookie-settings.component";
import {FontService} from "./shared/services/font.service";
import {TopBarEntry} from "./shared/types/topBarEntry";
import {StripeService} from "./shared/services/stripe.service";
import {CookieNoticeComponent} from './shared/components/cookie-notice/cookie-notice.component';
import {Location} from '@angular/common';
import {getCookie, setCookie} from "../utility/consts/cookie";
import {GoogleAnalyticsService} from "./shared/services/googleAnalytics.service";
import {FavIconService} from "./shared/services/fav-icon.service";
import {DEFAULT_FAVICON_HREF, setFavicon} from "./shared/helpers/favicon";
import {PosthogService} from "./shared/services/posthog.service";
import {isCustomDomain} from "./shared/helpers/portal-functions";
import {BrandTranslationService} from "./shared/services/brand-translation.service";
import {PortalLayoutService} from "./shared/services/portal-layout.service";
import {StorageService} from "./shared/services/storage/storage.service";
import {logger} from './shared/services/logging.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: true,
    imports: [TranslocoModule, RouterOutlet, CookieNoticeComponent]
})
export class AppComponent implements OnInit {
    prepareRoute(outlet: RouterOutlet) {
        return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
    }

    private portalInitializedForBrand: string | null = null;

    title = 'dashboard';

    isLoading: boolean = true;
    isDashboard: boolean = true;
    isTradeInPage: boolean = false;
    isRepairPage: boolean = false;
    isOrdersPage: boolean = false;
    isTradeInLandingPage: boolean = false;
    isRepairLandingPage: boolean = false;
    isOrdersLandingPage: boolean = false;
    isOfferAccept: boolean = false;
    isOfferRefuse: boolean = false;
    isBrandLoaded: boolean = false;
    isBrandStyleLoaded: boolean = false;
    isBrandHeadlineFontLoaded: boolean = false;
    isBrandBodyFontLoaded: boolean = false;

    public showTradeInNotActive: boolean = false;
    public showRepairNotActive: boolean = false;
    public showOrdersNotActive: boolean = false;

    public shopImageSrc: string = "";

    public is404: boolean = false;
    public isPasswordReset: boolean = false;

    public param: string = "";
    public headline: string = "";
    public headline2: string = "";
    public subText: string = "";
    public apiKey: string = "";
    private companyId: string = "";

    selectableLanguages = [{name: "Deutsch", value: "de"}, {name: "English", value: "en"}];

    public showCookieNotice = false;

    currentEntryIndex = 0;
    currentEntry: TopBarEntry = {text: "", url: ""};
    route = inject(ActivatedRoute);
    location = inject(Location);

    constructor(
        public authService: AuthService,
        private favIconService: FavIconService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private router: Router,
        private iconRegistry: MatIconRegistry,
        private translocoService: TranslocoService,
        private brandService: BrandService,
        private firebaseService: FirebaseService,
        private titleService: Title,
        private logoService: LogoService,
        private fontService: FontService,
        private stripeService: StripeService,
        private posthogService: PosthogService,
        public renderer: Renderer2,
        public dialog: MatDialog,
        private sanitizer: DomSanitizer,
        private storageService: StorageService,
        private brandTranslationService: BrandTranslationService,
        private portalLayoutService: PortalLayoutService,
    ) {

        iconRegistry.addSvgIcon(
            'add',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/add.svg'));
        iconRegistry.addSvgIcon(
            'add_white',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/add_white.svg'));
        iconRegistry.addSvgIcon(
            'admin_panel_settings',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/admin_panel_settings.svg'));
        iconRegistry.addSvgIcon(
            'arrow_down',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow_down.svg'));
        iconRegistry.addSvgIcon(
            'arrow_left',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow_left.svg'));
        iconRegistry.addSvgIcon(
            'arrow_right',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow_right.svg'));
        iconRegistry.addSvgIcon(
            'arrow_up',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow_up.svg'));
        iconRegistry.addSvgIcon(
            'burger_menu',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/burger_menu.svg'));
        iconRegistry.addSvgIcon(
            'checkmark',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/checkmark.svg'));
        iconRegistry.addSvgIcon(
            'checkmark-double',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/checkmark-double.svg'));
        iconRegistry.addSvgIcon(
            'checkmark_with_circle',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/checkmark_with_circle.svg'));
        iconRegistry.addSvgIcon(
            'checkmark_with_empty_circle',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/checkmark_with_empty_circle.svg'));
        iconRegistry.addSvgIcon(
            'chevron_down',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron_down.svg'));
        iconRegistry.addSvgIcon(
            'chevron_left',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron_left.svg'));
        iconRegistry.addSvgIcon(
            'chevron_right',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron_right.svg'));
        iconRegistry.addSvgIcon(
            'chevron_up',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/chevron_up.svg'));
        iconRegistry.addSvgIcon(
            'close',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/close.svg'));
        iconRegistry.addSvgIcon(
            'close_with_circle',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/close_with_circle.svg'));
        iconRegistry.addSvgIcon(
            'arrow-single-left',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow-single-left.svg'));
        iconRegistry.addSvgIcon(
            'arrow-left-right',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/arrow-left-right.svg'));
        iconRegistry.addSvgIcon(
            'delete',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/delete.svg'));
        iconRegistry.addSvgIcon(
            'deleteX',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/deleteX.svg'));
        iconRegistry.addSvgIcon(
            'reset',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/reset.svg'));
        iconRegistry.addSvgIcon(
            'download',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/download.svg'));
        iconRegistry.addSvgIcon(
            'download_white',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/download_white.svg'));
        iconRegistry.addSvgIcon(
            'edit',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/edit.svg'));
        iconRegistry.addSvgIcon(
            'edit_hollow',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/edit_hollow.svg'));
        iconRegistry.addSvgIcon(
            'edit-pen',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/edit-pen.svg'));
        iconRegistry.addSvgIcon(
            'desktop',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/desktop.svg'));
        iconRegistry.addSvgIcon(
            'mobile',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/mobile.svg'));
        iconRegistry.addSvgIcon(
            'file',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/file.svg'));
        iconRegistry.addSvgIcon(
            'filter',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/filter.svg'));
        iconRegistry.addSvgIcon(
            'google',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/google.svg'));
        iconRegistry.addSvgIcon(
            'help',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/help.svg'));
        iconRegistry.addSvgIcon(
            'hide',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/hide.svg'));
        iconRegistry.addSvgIcon(
            'image',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/image.svg'));
        iconRegistry.addSvgIcon(
            'indentation',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/indentation.svg'));
        iconRegistry.addSvgIcon(
            'logout',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/logout.svg'));
        iconRegistry.addSvgIcon(
            'mail',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/mail.svg'));
        iconRegistry.addSvgIcon(
            'more',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/more.svg'));
        iconRegistry.addSvgIcon(
            'more_vert',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/more_vert.svg'));
        iconRegistry.addSvgIcon(
            'payment',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/payment.svg'));
        iconRegistry.addSvgIcon(
            'more_mobile',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/more_mobile.svg'));
        iconRegistry.addSvgIcon(
            'print',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/print.svg'));
        iconRegistry.addSvgIcon(
            'search',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/search.svg'));
        iconRegistry.addSvgIcon(
            'send',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/send.svg'));
        iconRegistry.addSvgIcon(
            'settings',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/settings.svg'));
        iconRegistry.addSvgIcon(
            'show',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/show.svg'));
        iconRegistry.addSvgIcon(
            'upload',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/upload.svg'));
        iconRegistry.addSvgIcon(
            'upload-file',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/upload-file.svg'));
        iconRegistry.addSvgIcon(
            'usermail',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/user_mail.svg'));
        iconRegistry.addSvgIcon(
            'user',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/user.svg'));
        iconRegistry.addSvgIcon(
            'url',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/url.svg'));
        iconRegistry.addSvgIcon(
            'unlink',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/unlink.svg'));
        iconRegistry.addSvgIcon(
            'warning',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/warning.svg'));
        iconRegistry.addSvgIcon(
            'cactus',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/empty-icons/cactus.svg'));
        iconRegistry.addSvgIcon(
            'ghost',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/empty-icons/ghost.svg'));
        iconRegistry.addSvgIcon(
            'meditate',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/empty-icons/meditate.svg'));
        iconRegistry.addSvgIcon(
            'human',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/return-history/human.svg'));
        iconRegistry.addSvgIcon(
            'money',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/return-history/money.svg'));
        iconRegistry.addSvgIcon(
            'monocle',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/return-history/monocle.svg'));
        iconRegistry.addSvgIcon(
            'party',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/return-history/party.svg'));
        iconRegistry.addSvgIcon(
            'transporter',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/return-history/transporter.svg'));
        iconRegistry.addSvgIcon(
            'transport_company',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/transport_company.svg'));
        iconRegistry.addSvgIcon(
            'copy',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/copy.svg'));
        iconRegistry.addSvgIcon(
            'csv',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/csv.svg'));
        iconRegistry.addSvgIcon(
            'info',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/info.svg'));
        iconRegistry.addSvgIcon(
            'info-gray',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/info-gray.svg'));
        iconRegistry.addSvgIcon(
            'input',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/input.svg'));
        iconRegistry.addSvgIcon(
            'link',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/link.svg'));
        iconRegistry.addSvgIcon(
            'linear-scale',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/linear-scale.svg'));
        iconRegistry.addSvgIcon(
            'wooCommerce',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/woocommerce.svg'));
        iconRegistry.addSvgIcon(
            'shopify',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/shopify.svg'));
        iconRegistry.addSvgIcon(
            'magento',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/magento.svg'));
        iconRegistry.addSvgIcon(
            'dropOff',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/dropOff.svg'));
        iconRegistry.addSvgIcon(
            'gmail',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gmail.svg'));
        iconRegistry.addSvgIcon(
            'dhl',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/dhl.svg'));
        iconRegistry.addSvgIcon(
            'dhl-return',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/dhl_return.svg'));
        iconRegistry.addSvgIcon(
            'googleAnalytics',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/googleAnalytics.svg'));
        iconRegistry.addSvgIcon(
            'numi',
            sanitizer.bypassSecurityTrustResourceUrl('assets/images/logo.svg'));
        iconRegistry.addSvgIcon(
            'draggable',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/draggable.svg'));
        iconRegistry.addSvgIcon(
            'clock',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/clock.svg'));
        iconRegistry.addSvgIcon(
            'location',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/location.svg'));
        iconRegistry.addSvgIcon(
            'calendar',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/calendar.svg'));
        iconRegistry.addSvgIcon(
            'fileTypeJson',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons//file-types/json.svg'));
        iconRegistry.addSvgIcon(
            'fileTypeXlsx',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons//file-types/excel.svg'));
        iconRegistry.addSvgIcon(
            'fileTypePdf',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons//file-types/pdf.svg'));
        iconRegistry.addSvgIcon(
            'disconnect_blue',
            sanitizer.bypassSecurityTrustResourceUrl('assets/icons/calendar-integrations/disconnect.svg'));

        window.addEventListener('scroll', (event) => {
            const h1 = document.querySelector('h1');
            if (h1 && this.isDashboard) {
                if (window.scrollY > 35) {
                    h1.classList.add('in-header-area');

                    const header = document.querySelector('.header h1');
                    if (header) {
                        (header as HTMLHeadingElement).classList.add('in-header-area');
                        const htmlSpanElement = header.querySelector("span");
                        if (htmlSpanElement) {
                            htmlSpanElement.classList.add('in-header-area');
                        }
                    }
                    const htmlSpanElement = h1.querySelector("span");
                    if (htmlSpanElement) {
                        htmlSpanElement.classList.add('in-header-area');
                    }
                    const timestamp = document.querySelector('.timestamp');
                    if (timestamp) {
                        (timestamp as HTMLSpanElement).classList.add('in-header-area');
                    }
                } else {
                    const header = document.querySelector('.header h1');
                    if (header) {
                        (header as HTMLHeadingElement).classList.remove('in-header-area');
                        const htmlSpanElement = header.querySelector("span");
                        if (htmlSpanElement) {
                            htmlSpanElement.classList.remove('in-header-area');
                        }
                    }
                    h1.classList.remove('in-header-area');
                    //   h1.style.color = '(var(--text-color))';
                    const htmlSpanElement = h1.querySelector("span");
                    if (htmlSpanElement) {
                        htmlSpanElement.classList.remove('in-header-area');
                    }
                    const timestamp = document.querySelector('.timestamp');
                    if (timestamp) {
                        (timestamp as HTMLSpanElement).classList.remove('in-header-area');
                        // (header as HTMLSpanElement).style.color = '(var(--text-color))';
                    }
                }
            }

        });
    }

    async ngOnInit() {
        const allowCookies = this.storageService.get(this.storageService.keys.allowCookies);

        const allKeys = Object.keys(localStorage);
        let keysToDelete = allKeys.filter(key => !key.includes('selectedProduct') && !key.includes('allowCookies') && !key.includes('cookieSettings'));

        const brand = getCookie('Brand') || 'defaultBrand';
        keysToDelete = keysToDelete.filter(key =>
            !key.includes(brand + "userData")
            && !key.includes(brand + "isShipping")
            && !key.includes(brand + "termsAccepted")
            && !key.includes("timeframe_enum")
            && !key.includes("timeframe")
            && !key.includes(brand + "productType")
            && !key.includes(brand + "currentlySelected")
            && !key.includes(brand + "conditionList")
        );

        keysToDelete.forEach(key => {
            this.storageService.remove(key);
        })

        //wait 2 seconds before showing the cookie notice
        setTimeout(() => {
            this.showCookieNotice = (allowCookies == undefined || false);
        }, 2000);

        const host = location.hostname;

        if (host.includes('test.mario-schneller.de')) {
            //check if it is already redirected
            if (!location.pathname.includes('/tchibo')) {
                location.replace('/tchibo');
                console.log('Redirecting to /tchibo');
            }
        } else if (host.includes('tchibo-resale.de') || host.includes('rueckkauf.tchibo.de')) {
            //check if it is already redirected
            if (!location.pathname.includes('/tchibo')) {
                location.replace('/tchibo');
                console.log('Redirecting to /tchibo');
            }
        } else if (host.includes('trade-in.mamelo.de')) {
            //check if it is already redirected
            if (!location.pathname.includes('/mamelo')) {
                location.replace('/mamelo');
                console.log('Redirecting to /mamelo');
            }
        }

        this.router.events.subscribe(async event => {
            if (event instanceof NavigationEnd) {

                if (event.urlAfterRedirects == '/') {
                    if (isCustomDomain(location.hostname)) {
                        logger.debug("navigated to root on custom domain, skipping dashboard redirect");
                        // The portal-routing.module via the :params route should handle the further routing,
                        // or MainPortalComponent can handle it.
                    } else {
                        logger.debug("navigated to root, redirecting to dashboard");
                        this.router.navigateByUrl('/dashboard', {replaceUrl: true, skipLocationChange: false});
                        return;
                    }
                }
                await this.authService.loadCompanyInfoFromDatabase();

                this.is404 = event.urlAfterRedirects.indexOf('/404') > -1;
                this.isPasswordReset =
                    event.urlAfterRedirects === '/action' || event.urlAfterRedirects === '/reset-success';
                this.isDashboard = event.urlAfterRedirects.includes('/dashboard') && !isCustomDomain(location.hostname);
                this.isOfferAccept = event.urlAfterRedirects.includes('/offer-accept');
                this.isOfferRefuse = event.urlAfterRedirects.includes('/offer-refuse');
                this.isRepairPage = event.urlAfterRedirects.includes('/repair');
                this.isTradeInPage = event.urlAfterRedirects.includes('/trade-in');
                if (this.isOfferAccept || this.isOfferRefuse) {
                    this.isDashboard = false;
                    this.titleService.setTitle('Dein Angebot');
                }
                if (this.isDashboard) {

                    setFavicon(document, DEFAULT_FAVICON_HREF);

                    this.isBrandStyleLoaded = true;
                    this.isBrandHeadlineFontLoaded = true;
                    this.isBrandBodyFontLoaded = true;
                    this.authService.setBrandStyleLoaded(this.isBrandStyleLoaded);
                    try {
                        await this.authService.loadBrandFromDatabase();
                        if (this.authService.user()) {
                            // Guarded like loadCompanyInfoFromDatabase/loadBrandFromDatabase above:
                            // was re-reading /users/{uid} on every navigation under /dashboard/*.
                            await this.authService.getUserDetail(true);
                            this.checkSubscription(true);
                        }
                        this.titleService.setTitle('koorvi - Dashboard');
                        this.isLoading = false;

                        const browserLang = getBrowserLang();
                        if (this.authService.userData.selectedLanguage && this.authService.userData.selectedLanguage.length > 0) {
                            const lang = this.selectableLanguages.find(lang => lang.name === this.authService.userData.selectedLanguage || lang.value === this.authService.userData.selectedLanguage);
                            this.translocoService.setActiveLang(lang?.value + "");
                            this.isLoading = false;

                        } else if (browserLang === 'de' || browserLang === 'en') {
                            this.translocoService.setActiveLang(browserLang);
                            this.isLoading = false;
                        } else {
                            this.translocoService.setActiveLang('de');
                            this.isLoading = false;
                        }
                    } catch (e) {
                        logger.error(e);
                    }
                }

                if (this.is404) {
                    logger.debug("navigated to 404")
                    this.titleService.setTitle('404 - Not Found');
                    this.isLoading = false;
                    return;
                }

                if (!this.isDashboard) {

                    const brandMapping = await this.brandService.getBrandByDomain(host);

                    if (brandMapping) {
                        this.authService.setBrandName(brandMapping);
                        logger.debug("Brand mapping found for host " + host + ": " + this.authService.brandName);
                        logger.debug("isCustomDomain", isCustomDomain(host));

                        // Custom domain: do not redirect, load brand directly
                        logger.debug('Custom domain detected, loading brand: ' + this.authService.brandName);
                        await this.authService.loadBrandFromDatabase(this.authService.brandName);
                        this.isBrandLoaded = true;

                    } else {
                        logger.warn("No brand mapping found for host " + host);

                        let pathname = this.location.path().trim().split('/')[1];
                        logger.debug("Extracted pathname", pathname);
                        // ignore query params
                        pathname = pathname.split('?')[0];
                        this.authService.setBrandName(pathname);
                    }

                    try {
                        let pathname = this.authService.brandName;

                        if (isCustomDomain(location.hostname) && (!pathname || pathname === 'trade-in' || pathname === 'repair' || pathname === 'offer-accept' || pathname === 'offer-refuse')) {
                            const brandMapping = await this.brandService.getBrandByDomain(location.hostname);
                            if (brandMapping) {
                                pathname = brandMapping;
                            }
                        }

                        this.posthogService.capture('$pageview portal', {path: event.urlAfterRedirects});

                        if (this.portalInitializedForBrand !== pathname) {
                            this.portalInitializedForBrand = pathname;

                            await this.authService.loadBrandFromDatabase(pathname);
                            this.checkSubscription().then();
                            this.translocoService.setActiveLang('de');
                            this.registerIconOverrides();

                            void this.applyBrandFavicon(this.authService.companyData.id);

                            if (!window.gtag) {
                                this.googleAnalyticsService.loadGA4Tracking();
                            }

                            this.fontService.getHeadlineFont(this.authService.companyData.portalSettings.headlineFont).then((url) => {
                                if (url) {
                                    const fontLink = document.getElementById(
                                        'headline-font'
                                    ) as HTMLLinkElement;
                                    if (fontLink) {
                                        fontLink.href = url;
                                    } else {
                                        this.addHeadlineFontToStylesheet('header-font', url);
                                    }
                                } else {
                                    this.isBrandHeadlineFontLoaded = true;
                                }
                            });

                            this.fontService.getBodyFont(this.authService.companyData.portalSettings.bodyFont).then((url) => {
                                if (url) {
                                    const fontLink = document.getElementById(
                                        'font'
                                    ) as HTMLLinkElement;
                                    if (fontLink) {
                                        fontLink.href = url;
                                    } else {
                                        this.addBodyFontToStylesheet('body-font', url);
                                    }
                                } else {
                                    this.isBrandBodyFontLoaded = true;
                                }
                            });
                            this.getPortalLogoUrl();
                            this.loadPortal(pathname);
                            if (!isCustomDomain(location.hostname)) {
                                setCookie('Brand', pathname, 365);
                            }
                            this.isLoading = false;
                        }

                        const brandName = this.authService.companyData.portalSettings.brandName ? this.authService.companyData.portalSettings.brandName : pathname;

                        if (this.isRepairPage) {
                            if (!this.authService.companyData.portalSettings.isRepairActive) {
                                //    this.router.navigateByUrl('www.koorvi.com/404', {replaceUrl: true, skipLocationChange: true});
                                return;
                            }
                            // Standard portals load the repair settings at the service step; the classic layout
                            // loads them up front, as the old portal did.
                            if (this.portalLayoutService.isClassic) {
                                await this.authService.loadRepairSettingsFromDatabase();
                            }
                            const repairTitle = this.authService.companyData.repairSettings?.titleTag;
                            this.titleService.setTitle(repairTitle ? repairTitle.replace("{{Brand}}", brandName) : brandName + ' - Repair');
                        }
                        // The brand root (landing page) belongs to the trade-in flow as well.
                        if (this.isTradeInPage || (!this.isRepairPage && !this.isOfferAccept && !this.isOfferRefuse)) {
                            const titleTag = this.authService.companyData.portalSettings.titleTag;
                            if (titleTag) {
                                this.titleService.setTitle(titleTag.replace("{{Brand}}", brandName));
                            } else {
                                this.titleService.setTitle(brandName + ' - Trade-In');
                            }
                        }
                    } catch (e) {
                        logger.error("error loading brand", e);
                    }
                }
                /*
                }else if (event.urlAfterRedirects.includes('/orders')) {
                        this.authService.isPortalOrders = true;
                        this.isOrdersLandingPage = false;

                        this.titleService.setTitle(pathname + ' - Orders');

                        if (event.urlAfterRedirects.endsWith('/orders')) {
                            this.isOrdersLandingPage = true;
                        } else {
                            this.isOrdersLandingPage = false;
                        }
                    }
                 */
            }
        });

    }

    loadPortal(params: string) {
        if (params) {
            this.brandService.getBrandByName(params).then(async (brand) => {
                if (brand) {
                    this.authService.setBrandName(params);
                    if (!this.isBrandLoaded) {
                        await this.authService.loadBrandFromDatabase();
                    }
                    this.isBrandLoaded = true;
                    const textOf = (value: unknown): string => typeof value === 'string' ? value : '';
                    this.headline = textOf(brand['headline']);
                    this.headline2 = textOf(brand['headline2']);
                    this.subText = textOf(brand['subText']);
                    this.apiKey = textOf(brand['apiKey']);
                    this.companyId = textOf(brand['id']);

                    const theme = this.portalLayoutService.settings.theme;
                    Promise.all([
                        this.loadTheme(theme),
                        this.brandTranslationService.applyOverrides(theme),
                    ]).then(() => this.firebaseService.getStyle(this.companyId)).then((url) => {
                        this.loadStyle(url)
                    }).catch((e) => {
                        logger.debug("no custom style found", e);
                        this.isLoading = false;
                        this.isBrandStyleLoaded = true;
                        this.authService.setBrandStyleLoaded(this.isBrandStyleLoaded);
                    });

                } else {
                    logger.debug("Brand not found", params);
                }

            });
        }
    }

    // A brand may ship its own artwork for icons the portal registers by name.
    private registerIconOverrides() {
        const overrides = this.portalLayoutService.settings.iconOverrides;
        for (const [name, url] of Object.entries(overrides)) {
            this.iconRegistry.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(url));
        }
    }

    async applyBrandFavicon(companyId: string): Promise<void> {
        try {
            const url = await this.favIconService.getFavIocn(companyId);
            setFavicon(document, url || DEFAULT_FAVICON_HREF);
        } catch (e: unknown) {
            logger.error("error loading brand favicon", e);
            setFavicon(document, DEFAULT_FAVICON_HREF);
        }
    }

    // The theme stylesheet is bundled with the app (angular.json, not injected) and sits between the
    // global stylesheet and the company's custom css. Resolves once it applies, or at once without a theme.
    loadTheme(theme: string): Promise<void> {
        if (!theme || document.getElementById('brand-theme')) {
            return Promise.resolve();
        }
        return new Promise((resolve) => {
            const link = document.createElement('link');
            link.id = 'brand-theme';
            link.rel = 'stylesheet';
            link.href = `/theme-${theme}.css`;
            link.onload = () => resolve();
            link.onerror = () => {
                logger.error(`theme stylesheet theme-${theme}.css not found`);
                resolve();
            };
            document.head.appendChild(link);
        });
    }

    loadStyle(styleName: string) {

        if (this.isBrandStyleLoaded) {
            return;
        }

        const head = document.getElementsByTagName('head')[0];
        logger.debug("head", head);

        const themeLink = document.getElementById(
            'client-theme'
        ) as HTMLLinkElement;
        if (themeLink) {
            themeLink.href = styleName;
            this.isLoading = false;
            this.isBrandStyleLoaded = true;
            this.authService.setBrandStyleLoaded(this.isBrandStyleLoaded);
            document.body.offsetHeight; // Trigger reflow
        } else {
            const style = document.createElement('link');
            style.id = 'client-theme';
            style.rel = 'stylesheet';
            style.href = `${styleName}`;
            style.onload = () => {
                this.isLoading = false;
                this.isBrandStyleLoaded = true;
                this.authService.setBrandStyleLoaded(this.isBrandStyleLoaded);
                document.body.offsetHeight; // Trigger reflow
            }

            head.appendChild(style);
        }
    }

    async addHeadlineFontToStylesheet(fontName: string, fontUrl: string) {
        // Erzeuge FontFace-Objekt
        const font = new FontFace(fontName, `url(${fontUrl})`);

        try {
            // Lade die Font (asynchron!)
            await font.load();

            // Füge sie dem Dokument hinzu
            (document as any).fonts.add(font);

            // Optional: Reflow anstoßen
            document.body.offsetHeight;

            this.isBrandHeadlineFontLoaded = true;
            if (this.isBrandBodyFontLoaded) {
                this.isLoading = false;
            }

        } catch (err) {
            logger.error(`Fehler beim Laden der Font "${fontName}":`, err);
        }
    }

    async addBodyFontToStylesheet(fontName: string, fontUrl: string) {
        // Erzeuge FontFace-Objekt
        const font = new FontFace(fontName, `url(${fontUrl})`);

        try {
            // Lade die Font (asynchron!)
            await font.load();

            // Füge sie dem Dokument hinzu
            (document as any).fonts.add(font);

            // Optional: Reflow anstoßen
            document.body.offsetHeight;

            this.isBrandBodyFontLoaded = true;
            if (this.isBrandHeadlineFontLoaded) {
                this.isLoading = false;
            }

        } catch (err) {
            logger.error(`Fehler beim Laden der Font "${fontName}":`, err);
        }
    }

    getBannerImage(): string {
        switch (this.authService.userData.selectedDesign) {
            case 0:
                return '../assets/images/banner/banner_geometry.avif';
            case 1:
                return '../assets/images/banner/banner_nature.avif';
            case 2:
                return '../assets/images/banner/banner_simplistic.png';
            default:
                return '../assets/images/banner/banner_geometry.png';
        }
    }

    goToShop() {
        let url = this.authService.companyData.portalSettings.backButtonUrl;
        if (!/^https?:\/\//i.test(url)) {
            url = 'https://' + url;
        }
        window.location.href = url;
    }

    goToDashboard() {
        this.router.navigateByUrl('/dashboard', {replaceUrl: true, skipLocationChange: false});
    }

    goToDashboardSubscriptions() {
        window.open('/dashboard/subscription', '_blank');
    }

    goToKoorvi() {
        //open koorvi in new tab
        window.open('https://www.koorvi.com', '_blank');
    }

    getPortalLogoUrl() {
        this.logoService.getPortalLogoUrl(this.authService.companyData.id).then((logo: any) => {
            if (logo) {
                this.shopImageSrc = logo;
            }
        });
    }

    async checkSubscription(forceCheck: boolean = false) {

        await this.authService.loadCompanyInfoFromDatabase();

        if (!forceCheck && this.authService.subscriptionChecked) {
            return;
        }

        if (this.authService.companyData.isPilot) {
            this.showTradeInNotActive = false;
            this.showRepairNotActive = false;
            this.showOrdersNotActive = false;
            this.authService.showTradeInNotActive = false;
            this.authService.showRepairNotActive = false;
            this.authService.showOrdersNotActive = false;
            this.authService.showNoActiveSubscription = false;

            return;
        }

        if ((this.authService.companyData.stripeCustomerId === "" || this.authService.companyData.stripeCustomerId === undefined)
            && (this.authService.companyData.activeSubscriptionId === "" || this.authService.companyData.activeSubscriptionId === undefined)) {
            this.showTradeInNotActive = true;
            this.showRepairNotActive = true;
            this.showOrdersNotActive = true;
            this.authService.showTradeInNotActive = true;
            this.authService.showRepairNotActive = true;
            this.authService.showOrdersNotActive = true
            this.authService.showNoActiveSubscription = true;

            return;
        }
        const promise = await this.stripeService.getCustomerSubscriptions(this.authService.companyData.stripeCustomerId);
        promise.subscribe((json: any) => {

            // If no subscription is active, redirect to the selection page
            if (!json.data || json.data.length === 0) {
                this.showTradeInNotActive = true;
                this.showRepairNotActive = true;
                this.showOrdersNotActive = true;
                this.authService.showTradeInNotActive = true;
                this.authService.showRepairNotActive = true;
                this.authService.showOrdersNotActive = true;
                this.authService.showNoActiveSubscription = true;
            } else if (json.data.filter((sub: any) => sub.status === "active").length === 0) {
                this.showTradeInNotActive = true;
                this.showRepairNotActive = true;
                this.showOrdersNotActive = true;
                this.authService.showTradeInNotActive = true;
                this.authService.showRepairNotActive = true;
                this.authService.showOrdersNotActive = true
                this.authService.showNoActiveSubscription = true;
            } else {
                this.showTradeInNotActive = false;
                this.showRepairNotActive = false;
                this.showOrdersNotActive = false;
                this.authService.showTradeInNotActive = false;
                this.authService.showRepairNotActive = false;
                this.authService.showOrdersNotActive = false;
                this.authService.showNoActiveSubscription = false;
            }

            this.authService.subscriptionChecked = true;
        });
    }

    public openCookieSettings() {
        this.renderer.addClass(document.body, 'modal-open');

        const dialogRef = this.dialog.open(CookieSettingsComponent, {
            panelClass: 'modal-background-530',
            data: {}
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            this.renderer.removeClass(document.body, 'modal-open');
            if (result) {
                if (result.statisticCookies && result.marketingCookies) {
                    this.allowCookies();
                } else {
                    this.declineCookies();
                }
            }

            this.renderer.removeClass(document.body, 'modal-open');
        });
    }

    // A brand can switch off its portal notice; Koorvi's own dashboard notice always shows.
    shouldShowCookieNotice(): boolean {
        return this.showCookieNotice
            && (this.isDashboard || this.authService.companyData?.portalSettings?.showCookieNotice !== false);
    }

    public allowCookies() {
        this.storageService.set(this.storageService.keys.allowCookies, true);
        this.googleAnalyticsService.enableTracking();
        this.showCookieNotice = false;
    }

    public declineCookies() {
        this.storageService.set(this.storageService.keys.allowCookies, false);
        this.googleAnalyticsService.disableTracking();
        this.showCookieNotice = false;
    }
}
